var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoSquare = function SvgInfoSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "info-square_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 4h56v56H4zm31.818 17.818v-7.636h-7.636v7.636zm-14 11.455h6.364v6.363h-6.364v7.637h20.364v-7.637h-6.364v-14h-14z",
    clipRule: "evenodd"
  })));
};
export { SvgInfoSquare as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQgNEg2MFY2MEg0VjRaTTM1LjgxODIgMjEuODE4MlYxNC4xODE4SDI4LjE4MThWMjEuODE4MkgzNS44MTgyWk0yMS44MTgyIDMzLjI3MjdIMjguMTgxOFYzOS42MzY0SDIxLjgxODJWNDcuMjcyN0g0Mi4xODE4VjM5LjYzNjRIMzUuODE4MlYyNS42MzY0SDIxLjgxODJWMzMuMjcyN1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";